/// <amd-module name="Build/Admin/Common/Stores/AgentDefinitionStore" />
import { Store } from "VSS/Reflux/Store";

import { AgentDefinition } from "PoolProvider/Shared/Contracts/PoolProviderShared";

export class AgentDefinitionStore extends Store {
    public state: AgentDefinition[] = [];

    constructor() {
        super("AgentDefinitionStore");
    }

    public updateAgentDefinitions = (agentDefinitions: AgentDefinition[]): void => {
        this.state =  agentDefinitions.splice(0);
        this.emitChanged();
    }
}
